$('[data-behaviour="back-to-top"]').on('click', function (e) {
    e.preventDefault();

    requestAnimationFrame(backToTop);
});

function backToTop() {
    $('html, body').animate({
        scrollTop: 0
    }, 500);
}